export const strikeThrough = (text: string) =>
  text
    .split("")
    .map((char) => char + "\u0336")
    .join("");
